import React from 'react'
import {
  TextInput,
  SimpleForm,
  required,
  Create,
  useNotify,
  useRedirect,
} from 'react-admin'

import { Grid, Paper, Typography, makeStyles } from '@material-ui/core'

import { Tooltip } from 'components'

const useStyles = makeStyles({
  container: {
    width: '100%',
  },
  gridContainer: {
    width: '100%',
  },
  formContainer: {
    backgroundColor: '#F5F5F5',
  },
  paperContainer: {
    padding: 16,
  },
})

export const CreateForm = (props: any) => {
  const redirect = useRedirect()
  const notify = useNotify()
  const classes = useStyles()
  const {
    formTitle = '',
    shouldRedirect = true,
    onSubmitSuccess = () => {},
    onSubmitFailure = () => {},
    toolbar = <></>,
    aside = <></>,
    ...rest
  } = props

  const onSuccess = () => {
    notify('post_successfully')
    if (shouldRedirect) redirect(props.basePath)
    onSubmitSuccess()
  }

  const onFailure = (error: any) => {
    onSubmitFailure(error)
    notify('post_failed', 'warning')
  }

  return (
    <Create
      aside={aside}
      {...rest}
      onSuccess={onSuccess}
      onFailure={onFailure}
      className={classes.container}
    >
      <SimpleForm
        warnWhenUnsavedChanges
        className={classes.formContainer}
        toolbar={toolbar}
        initialValues={{ description: ' ' }}
      >
        <Grid
          container
          direction="row"
          justify="center"
          alignItems="center"
          spacing={2}
          className={classes.gridContainer}
        >
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Paper className={classes.paperContainer}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography variant="h5" color="textSecondary" gutterBottom>
                  {formTitle}
                </Typography>
                <hr />
                <Typography variant="subtitle2" color="textPrimary">
                  Pergunta nos comentários
                </Typography>
                <Typography
                  variant="caption"
                  color="textSecondary"
                  display="block"
                  gutterBottom
                >
                  Para vincular uma Pergunta você deve visitar uma Aula.
                </Typography>
              </Grid>

              <Grid
                container
                spacing={2}
                className={classes.gridContainer}
                direction="column"
              >
                <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                  <Tooltip title={'comments_question.title'}>
                    <TextInput
                      fullWidth
                      label="Título"
                      source="title"
                      validate={[required('Obrigatório')]}
                    />
                  </Tooltip>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  )
}
